(function () {
  function setNavOpen(open) {
    var nav = document.querySelector("[data-nav]");
    var menu = document.querySelector("[data-menu]");
    if (!nav) return;
    nav.classList.toggle("is-open", open);
    document.body.classList.toggle("nav-open", open);
    if (menu) menu.setAttribute("aria-expanded", open ? "true" : "false");
  }

  document.addEventListener("click", function (event) {
    var menu = event.target.closest("[data-menu]");
    if (menu) {
      var nav = document.querySelector("[data-nav]");
      setNavOpen(nav ? !nav.classList.contains("is-open") : false);
      return;
    }

    if (event.target.closest("[data-nav] a")) {
      setNavOpen(false);
    }

    var searchToggle = event.target.closest("[data-search-open]");
    if (searchToggle) {
      var panel = document.querySelector("[data-search-panel]");
      if (!panel) return;
      var opened = panel.classList.toggle("is-open");
      searchToggle.setAttribute("aria-expanded", opened ? "true" : "false");
      if (opened) {
        var input = panel.querySelector("input[name='q']");
        if (input) input.focus();
      }
      return;
    }

    var thumb = event.target.closest("[data-thumb]");
    if (thumb) {
      var full = thumb.getAttribute("data-full");
      var shot = document.querySelector("[data-photo]");
      if (shot && full) {
        shot.src = full;
        shot.removeAttribute("data-locked");
      }
      document.querySelectorAll("[data-thumb]").forEach(function (other) {
        other.removeAttribute("aria-current");
      });
      thumb.setAttribute("aria-current", "true");
      return;
    }

    var card = event.target.closest(".card");
    if (card && card.querySelector(".card__back") && event.target.closest(".card__media")) {
      if (window.matchMedia("(hover: none)").matches) {
        event.preventDefault();
        var showBack = !card.classList.contains("is-back");
        card.classList.toggle("is-back", showBack);
        var side = card.querySelector(".card__side");
        if (side) side.textContent = showBack ? "Front" : "Back";
      }
    }
  });

  function bindProductForm() {
    var form = document.querySelector("[data-product-form]") || document.querySelector('form[action*="/cart/add"]');
    var jsonNode = document.querySelector("[data-product-json]");
    if (!form || !jsonNode) return;
    var product;
    try {
      product = JSON.parse(jsonNode.textContent);
    } catch (error) {
      return;
    }
    if (!product || !product.variants) return;
    var idInput = form.querySelector("[data-variant-id]");
    var price = document.querySelector("[data-price]");
    var button = form.querySelector("[data-add]");
    var photo = document.querySelector("[data-photo]");

    function choices() {
      var picked = [];
      form.querySelectorAll(".opts").forEach(function (set, index) {
        var pressed = set.querySelector('[aria-pressed="true"]');
        picked[index] = pressed ? pressed.getAttribute("data-option-value") : "";
      });
      return picked;
    }

    function match(picked) {
      return product.variants.find(function (variant) {
        return picked.every(function (value, index) {
          return String(variant.options[index]) === String(value);
        });
      });
    }

    function comboExists(index, value, picked) {
      return product.variants.some(function (variant) {
        if (String(variant.options[index]) !== String(value)) return false;
        return picked.every(function (other, i) {
          if (i === index || !other) return true;
          return String(variant.options[i]) === String(other);
        });
      });
    }

    function paint(variant) {
      form.querySelectorAll(".opts").forEach(function (set, index) {
        var picked = choices();
        set.querySelectorAll(".opt").forEach(function (opt) {
          var value = opt.getAttribute("data-option-value");
          opt.disabled = !comboExists(index, value, picked);
        });
      });
      if (!variant) {
        if (button) {
          button.disabled = true;
          button.textContent = "Unavailable";
        }
        return;
      }
      if (idInput) idInput.value = String(variant.id);
      if (price) price.textContent = variant.price;
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? "Add to bag" : "Sold out";
      }
      if (photo && variant.featured_image && photo.getAttribute("data-locked") !== "true") {
        photo.src = variant.featured_image;
      }
      if (variant.id && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set("variant", String(variant.id));
          window.history.replaceState({}, "", url.toString());
        } catch (error) {
          /* ignore */
        }
      }
    }

    form.addEventListener("click", function (event) {
      var opt = event.target.closest(".opt");
      if (!opt || opt.disabled) return;
      var set = opt.closest(".opts");
      if (!set) return;
      set.querySelectorAll(".opt").forEach(function (other) {
        other.setAttribute("aria-pressed", other === opt ? "true" : "false");
      });
      var variant = match(choices());
      if (!variant) {
        variant = product.variants.find(function (item) {
          return item.available && String(item.options[Number(set.getAttribute("data-option-index"))]) === opt.getAttribute("data-option-value");
        }) || variant;
      }
      paint(variant);
    });

    paint(match(choices()) || product.variants.find(function (item) { return item.available; }) || product.variants[0]);
  }

  bindProductForm();

  /* Contact email. Assembled here so the address never sits in the page source for scrapers.
     Copy is the primary action because mailto only works if a desktop mail app is installed. */
  document.querySelectorAll("[data-mail]").forEach(function (link) {
    var user = link.getAttribute("data-mail-user");
    var domain = link.getAttribute("data-mail-domain");
    if (!user || !domain) return;
    var address = user + "@" + domain;
    var subject = link.getAttribute("data-mail-subject");
    var copyOnly = link.hasAttribute("data-mail-copy");
    link.href = "mailto:" + address + (subject ? "?subject=" + encodeURIComponent(subject) : "");
    var fallback = link.querySelector("noscript");
    if (fallback) fallback.remove();
    if (!link.textContent.trim()) link.textContent = address;
    if (!copyOnly) return;
    if (!link.getAttribute("data-mail-label")) {
      link.setAttribute("data-mail-label", link.textContent.trim() || "Copy email");
    }
    link.addEventListener("click", function (event) {
      event.preventDefault();
      var label = link.getAttribute("data-mail-label") || "Copy email";
      var done = function () {
        link.textContent = "Copied";
        window.setTimeout(function () {
          link.textContent = label;
        }, 1800);
      };
      var fail = function () {
        window.prompt("Copy this email", address);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(address).then(done).catch(fail);
      } else {
        fail();
      }
    });
  });

  /* Live status. Twitch via decapi.me. TikTok via TikTok's room API (read through r.jina.ai for CORS). */
  var TWITCH_UPTIME = "https://decapi.me/twitch/uptime/";
  var TIKTOK_ROOM = "https://www.tiktok.com/api-live/user/room/?aid=1988&sourceType=54&uniqueId=";
  var LIVE_TTL = 60 * 1000;
  var LIVE_POLL = 90 * 1000;
  var LIVE_KEY = "lf-live-v2";
  var liveTimerBound = false;

  function cleanHandle(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/^https?:\/\/(www\.)?(twitch\.tv\/|tiktok\.com\/@?)/, "")
      .replace(/^@/, "")
      .replace(/\/+$/, "");
  }

  function splitHandles(value) {
    return String(value || "")
      .split("|")
      .map(cleanHandle)
      .filter(Boolean);
  }

  function livePeople() {
    var people = [];
    var seen = {};
    function add(name, twitch, tiktok) {
      twitch = cleanHandle(twitch);
      tiktok = cleanHandle(tiktok);
      if (!twitch && !tiktok) return;
      var key = (twitch || "") + "|" + (tiktok || "") + "|" + (name || "");
      if (seen[key]) return;
      seen[key] = true;
      people.push({ name: name || twitch || tiktok, twitch: twitch, tiktok: tiktok });
    }
    var pill = document.querySelector("[data-live-pill]");
    if (pill) {
      var names = (pill.getAttribute("data-live-names") || "").split("|");
      var twitch = splitHandles(pill.getAttribute("data-live-twitch") || pill.getAttribute("data-live-channels"));
      var tiktok = splitHandles(pill.getAttribute("data-live-tiktok"));
      var n = Math.max(names.length, twitch.length, tiktok.length);
      for (var i = 0; i < n; i++) add((names[i] || "").trim(), twitch[i], tiktok[i]);
    }
    document.querySelectorAll("[data-live-twitch], [data-live-tiktok], [data-live-channel]").forEach(function (node) {
      add(
        node.getAttribute("data-live-name"),
        node.getAttribute("data-live-twitch") || node.getAttribute("data-live-channel"),
        node.getAttribute("data-live-tiktok")
      );
    });
    return people;
  }

  function liveChecks(people) {
    var jobs = [];
    var seen = {};
    people.forEach(function (person) {
      if (person.twitch && !seen["twitch:" + person.twitch]) {
        seen["twitch:" + person.twitch] = true;
        jobs.push({ key: "twitch:" + person.twitch, platform: "twitch", handle: person.twitch });
      }
      if (person.tiktok && !seen["tiktok:" + person.tiktok]) {
        seen["tiktok:" + person.tiktok] = true;
        jobs.push({ key: "tiktok:" + person.tiktok, platform: "tiktok", handle: person.tiktok });
      }
    });
    return jobs;
  }

  function readCache() {
    try {
      return JSON.parse(sessionStorage.getItem(LIVE_KEY) || "{}") || {};
    } catch (e) {
      return {};
    }
  }

  function writeCache(cache) {
    try {
      sessionStorage.setItem(LIVE_KEY, JSON.stringify(cache));
    } catch (e) {
      /* storage unavailable */
    }
  }

  function shortUptime(text) {
    var out = [];
    var days = /(\d+)\s*day/i.exec(text);
    var hours = /(\d+)\s*hour/i.exec(text);
    var minutes = /(\d+)\s*minute/i.exec(text);
    if (days) out.push(days[1] + "d");
    if (hours) out.push(hours[1] + "h");
    if (minutes && !days) out.push(minutes[1] + "m");
    return out.join(" ");
  }

  function parseUptime(text) {
    var t = (text || "").trim();
    if (!t) return { state: "unknown" };
    if (/is offline/i.test(t)) return { state: "offline" };
    if (/\d+\s*(second|minute|hour|day)/i.test(t)) return { state: "live", uptime: shortUptime(t) };
    return { state: "unknown" };
  }

  function parseTikTokRoom(text) {
    var start = (text || "").indexOf("{");
    if (start < 0) return { state: "unknown" };
    try {
      var data = JSON.parse(text.slice(start));
      var status = data && data.data && data.data.liveRoom && data.data.liveRoom.status;
      if (status == null) return { state: "unknown" };
      return Number(status) === 4 ? { state: "offline" } : { state: "live" };
    } catch (e) {
      return { state: "unknown" };
    }
  }

  function checkTwitch(handle) {
    return fetch(TWITCH_UPTIME + encodeURIComponent(handle), { cache: "no-store" })
      .then(function (response) {
        return response.ok ? response.text() : "";
      })
      .then(parseUptime);
  }

  function checkTikTok(handle) {
    return fetch("https://r.jina.ai/" + TIKTOK_ROOM + encodeURIComponent(handle), { cache: "no-store" })
      .then(function (response) {
        return response.ok ? response.text() : "";
      })
      .then(parseTikTokRoom);
  }

  function personStatus(person, cache) {
    var twitch = person.twitch ? cache["twitch:" + person.twitch] : null;
    var tiktok = person.tiktok ? cache["tiktok:" + person.tiktok] : null;
    var platforms = [];
    if (twitch && twitch.state === "live") platforms.push("Twitch");
    if (tiktok && tiktok.state === "live") platforms.push("TikTok");
    var known = (twitch && twitch.state !== "unknown") || (tiktok && tiktok.state !== "unknown");
    return {
      platforms: platforms,
      state: platforms.length ? "live" : known ? "offline" : "unknown",
      twitch: twitch || { state: "unknown" },
      tiktok: tiktok || { state: "unknown" },
      href: platforms[0] === "TikTok" && person.tiktok
        ? "https://www.tiktok.com/@" + person.tiktok + "/live"
        : person.twitch
          ? "https://www.twitch.tv/" + person.twitch
          : person.tiktok
            ? "https://www.tiktok.com/@" + person.tiktok
            : "#"
    };
  }

  function liveLabel(info, person) {
    if (info.state === "live") return "Live now · " + info.platforms.join(" + ");
    if (info.state === "offline") return "Offline";
    if (person.twitch && person.tiktok) return "Twitch · TikTok";
    if (person.tiktok) return "On TikTok";
    return "On Twitch";
  }

  function renderLive(cache) {
    var people = livePeople();
    var livePeopleNow = people.map(function (person) {
      return { person: person, info: personStatus(person, cache) };
    }).filter(function (row) {
      return row.info.state === "live";
    });

    document.querySelectorAll("[data-live-twitch], [data-live-tiktok], [data-live-channel]").forEach(function (node) {
      var person = {
        name: node.getAttribute("data-live-name") || "",
        twitch: cleanHandle(node.getAttribute("data-live-twitch") || node.getAttribute("data-live-channel")),
        tiktok: cleanHandle(node.getAttribute("data-live-tiktok"))
      };
      var info = personStatus(person, cache);
      node.setAttribute("data-live-state", info.state);
      var label = node.querySelector("[data-live-label]");
      if (label) label.textContent = liveLabel(info, person);
      var twitchCta = node.querySelector("[data-live-twitch-cta]");
      if (twitchCta) {
        twitchCta.textContent = info.twitch.state === "live" ? "Watch Twitch" : "Twitch";
        twitchCta.classList.toggle("btn--solid", info.twitch.state === "live");
      }
      var tiktokCta = node.querySelector("[data-live-tiktok-cta]");
      if (tiktokCta) {
        tiktokCta.href = info.tiktok.state === "live"
          ? "https://www.tiktok.com/@" + person.tiktok + "/live"
          : "https://www.tiktok.com/@" + person.tiktok;
        tiktokCta.textContent = info.tiktok.state === "live" ? "Watch TikTok" : "TikTok";
        tiktokCta.classList.toggle("btn--solid", info.tiktok.state === "live");
      }
      var oldCta = node.querySelector("[data-live-cta]");
      if (oldCta) {
        oldCta.textContent = info.state === "live" ? "Watch live" : "Visit channel";
        oldCta.href = info.href;
      }
    });

    var pill = document.querySelector("[data-live-pill]");
    if (pill) {
      if (livePeopleNow.length) {
        var first = livePeopleNow[0];
        pill.hidden = false;
        pill.href = first.info.href;
        var who = pill.querySelector("[data-live-pill-who]");
        if (who) {
          who.textContent = livePeopleNow.length > 1
            ? " · " + livePeopleNow.length + " streams"
            : " · " + first.person.name + " · " + first.info.platforms.join(" + ");
        }
      } else {
        pill.hidden = true;
      }
    }

    var section = document.querySelector("[data-live-section]");
    if (section) {
      var summary = section.querySelector("[data-live-summary]");
      if (summary) {
        if (livePeopleNow.length) {
          var bits = livePeopleNow.map(function (row) {
            return row.person.name + " on " + row.info.platforms.join(" + ");
          });
          summary.textContent = bits.length > 1
            ? bits.slice(0, -1).join(", ") + " and " + bits[bits.length - 1] + " are live right now."
            : bits[0] + " is live right now.";
        } else {
          summary.textContent = summary.getAttribute("data-offline-text") || "";
        }
      }
      section.setAttribute("data-live-any", livePeopleNow.length ? "true" : "false");
      var player = section.querySelector("[data-live-player]");
      if (player) {
        var twitchLive = livePeopleNow.find(function (row) {
          return row.info.twitch.state === "live" && row.person.twitch;
        });
        var embed = section.getAttribute("data-live-embed") === "true" && twitchLive;
        if (embed) {
          var channel = twitchLive.person.twitch;
          if (player.getAttribute("data-channel") !== channel) {
            player.setAttribute("data-channel", channel);
            player.innerHTML = "";
            var frame = document.createElement("iframe");
            frame.src =
              "https://player.twitch.tv/?channel=" +
              encodeURIComponent(channel) +
              "&parent=" +
              encodeURIComponent(location.hostname) +
              "&muted=true&autoplay=true";
            frame.setAttribute("allowfullscreen", "");
            frame.setAttribute("allow", "autoplay; fullscreen");
            frame.setAttribute("title", twitchLive.person.name + " live on Twitch");
            frame.setAttribute("loading", "lazy");
            player.appendChild(frame);
          }
          player.hidden = false;
        } else {
          player.hidden = true;
          player.removeAttribute("data-channel");
          player.innerHTML = "";
        }
      }
    }
  }

  function refreshLive(force) {
    var people = livePeople();
    var jobs = liveChecks(people);
    if (!jobs.length) return;
    var cache = readCache();
    var now = Date.now();
    renderLive(cache);

    var stale = jobs.filter(function (job) {
      return force || !cache[job.key] || now - (cache[job.key].ts || 0) > LIVE_TTL;
    });
    if (!stale.length) return;

    Promise.all(
      stale.map(function (job) {
        var request = job.platform === "tiktok" ? checkTikTok(job.handle) : checkTwitch(job.handle);
        return request
          .then(function (info) {
            info.ts = Date.now();
            cache[job.key] = info;
          })
          .catch(function () {
            cache[job.key] = { state: "unknown", ts: Date.now() };
          });
      })
    ).then(function () {
      writeCache(cache);
      renderLive(cache);
    });
  }

  function bindLive() {
    if (!livePeople().length) return;
    refreshLive(false);
    if (liveTimerBound) return;
    liveTimerBound = true;
    setInterval(function () {
      if (document.visibilityState === "visible") refreshLive(false);
    }, LIVE_POLL);
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible") refreshLive(false);
    });
  }

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var finePointer = window.matchMedia("(pointer: fine)").matches;

  function bindBoot() {
    var boot = document.querySelector("[data-boot]");
    if (!boot || boot.getAttribute("data-bound")) return;
    boot.setAttribute("data-bound", "true");
    if (reduceMotion) {
      boot.remove();
      return;
    }
    document.body.classList.add("is-booting");
    window.setTimeout(function () {
      boot.classList.add("is-gone");
      document.body.classList.remove("is-booting");
      window.setTimeout(function () { boot.remove(); }, 800);
    }, 1500);
  }

  function bindHeader() {
    var header = document.querySelector(".header");
    if (!header || header.getAttribute("data-bound")) return;
    header.setAttribute("data-bound", "true");
    var thin = function () {
      header.classList.toggle("is-thin", window.scrollY > 24);
    };
    thin();
    window.addEventListener("scroll", thin, { passive: true });
  }

  function bindReveals() {
    if (reduceMotion) return;
    document.querySelectorAll(".line, .panel, .card, .project, .streamer, .live__head, .closer .wrap, .mark-floor article").forEach(function (node) {
      if (!node.hasAttribute("data-reveal")) node.setAttribute("data-reveal", "");
    });
    if (!("IntersectionObserver" in window)) {
      document.querySelectorAll("[data-reveal]").forEach(function (node) { node.classList.add("is-in"); });
      return;
    }
    if (!window.lfReveal) {
      window.lfReveal = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            window.lfReveal.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    }
    document.querySelectorAll("[data-reveal]:not(.is-in)").forEach(function (node) {
      window.lfReveal.observe(node);
    });
  }

  function bindHero() {
    var hero = document.querySelector("[data-hero]");
    if (!hero) return;
    var plate = hero.querySelector(".hero__plate");
    if (hero.getAttribute("data-bound") || !finePointer || reduceMotion) return;
    hero.setAttribute("data-bound", "true");
    hero.addEventListener("pointermove", function (event) {
      var x = (event.clientX / window.innerWidth - 0.5) * 8;
      var y = (event.clientY / window.innerHeight - 0.5) * 5;
      if (plate) plate.style.transform = "translate(" + x + "px," + y + "px)";
    });
  }

  function bindSpot() {
    var spot = document.querySelector("[data-spot]");
    if (!spot || !finePointer || reduceMotion || spot.getAttribute("data-bound")) return;
    spot.setAttribute("data-bound", "true");
    spot.hidden = false;
    window.addEventListener("pointermove", function (event) {
      spot.style.left = event.clientX + "px";
      spot.style.top = event.clientY + "px";
    }, { passive: true });
    document.addEventListener("pointerover", function (event) {
      spot.classList.toggle("is-hot", !!event.target.closest("a, button, .opt, .card"));
    });
  }

  function bindWorld() {
    bindBoot();
    bindHeader();
    bindReveals();
    bindHero();
    bindSpot();
    bindTilt();
    bindLive();
  }

  function bindTilt() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (window.matchMedia("(pointer: coarse)").matches) return;
    document.querySelectorAll("[data-tilt]").forEach(function (node) {
      if (node.getAttribute("data-tilt-bound")) return;
      node.setAttribute("data-tilt-bound", "true");
      node.addEventListener("pointermove", function (event) {
        var box = node.getBoundingClientRect();
        var x = (event.clientX - box.left) / box.width - 0.5;
        var y = (event.clientY - box.top) / box.height - 0.5;
        node.style.transform =
          "perspective(900px) rotateX(" +
          (-y * 5).toFixed(2) +
          "deg) rotateY(" +
          (x * 7).toFixed(2) +
          "deg) translateY(-4px)";
      });
      node.addEventListener("pointerleave", function () {
        node.style.transform = "";
      });
    });
  }

  bindWorld();
  window.addEventListener("lf:page", bindWorld);
  window.addEventListener("resize", function () {
    if (window.matchMedia("(min-width: 981px)").matches) setNavOpen(false);
  });

  function stripSpam() {
    document.querySelectorAll("form").forEach(function (form) {
      if (form.classList.contains("note")) return;
      var action = (form.getAttribute("action") || "").toLowerCase();
      if (action.indexOf("/contact") !== -1) form.remove();
    });
    document.querySelectorAll("#shopify-chat, #ShopifyChat, inbox-online-store-chat").forEach(function (node) {
      node.remove();
    });
  }

  /* Contact topic shortcuts (e.g. Join the build). */
  var topicSelect = document.querySelector("#contact-topic");
  if (topicSelect) {
    document.querySelectorAll("[data-topic]").forEach(function (link) {
      link.addEventListener("click", function () {
        var topic = link.getAttribute("data-topic");
        if (!topic) return;
        topicSelect.value = topic;
      });
    });
    if (location.hash === "#partner") {
      topicSelect.value = "Join the build";
    }
  }

  /* On-site note. Honeypot plus a short delay so scrapers that auto-submit fail. */
  var note = document.querySelector("form.note");
  if (note) {
    var noteReady = Date.now();
    note.addEventListener("submit", function (event) {
      if (note.getAttribute("data-lf-ok") === "1") return;
      var trap = note.querySelector("[data-lf-trap]");
      if (trap && trap.value) {
        event.preventDefault();
        return;
      }
      var wait = 2500 - (Date.now() - noteReady);
      var button = note.querySelector("[type='submit']");
      if (wait > 0) {
        event.preventDefault();
        if (button) {
          button.disabled = true;
          button.textContent = "Sending";
        }
        window.setTimeout(function () {
          note.setAttribute("data-lf-ok", "1");
          if (note.requestSubmit) note.requestSubmit();
          else note.submit();
        }, wait);
        return;
      }
      if (button) {
        button.disabled = true;
        button.textContent = "Sending";
      }
    });
  }

  stripSpam();
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      stripSpam();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
